import React from 'react'

import { Modal } from '@/Atomic/Organisms/Modal'
import './RawDataModal.scss'

interface RawDataModalProps {
  isOpen: boolean
  close: () => void
  confirmationButtonText?: string
  title: string
  data: string[]
}
export const RawDataModal: React.FC<RawDataModalProps> = ({
  isOpen,
  close,
  title,
  data,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={close} closeOnOutsideClick={false}>
      <Modal.Header className="text-center" title={title} />
      <Modal.Body>
        <div className="pre-block">{data.join('\n')}</div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}
